import { getLiveSnapshot } from './live-transcript.ts';
import { LiveSegment } from '@utils/types/editors/live-transcript.ts';

export const loadLiveRange = async (
  sessionId: string,
  first = 1,
  last = Number.MAX_SAFE_INTEGER
) => {
  const segments: LiveSegment[] = [];
  let after = first - 1;
  while (after < last) {
    const page = await getLiveSnapshot(sessionId, after);
    segments.push(...page.segments.filter(row => row.sequence <= last));
    if (!page.has_more || page.next_cursor >= last) break;
    after = page.next_cursor;
  }
  return {
    segments,
    cursor: segments[segments.length - 1]?.sequence ?? first - 1
  };
};
